// extracted by mini-css-extract-plugin
export default {"actionBtn":"Ticket_actionBtn__UWsBf","confirm":"Ticket_confirm__3AzR1","reject":"Ticket_reject__ZCDPT"};